export function GetJenisSurat(jenis_surat) {
    let set_jenis = null;
    switch (jenis_surat) {
        case 'Surat Keterangan Belum Memiliki Rumah':
            set_jenis = 'belum-memiliki-rumah';

            break;
        case 'Surat Pernyataan Belum Menikah':
            set_jenis = 'belum-menikah';

            break;
        case 'Surat Keterangan Belum Menikah':
            set_jenis = 'belum-menikah/ii';

            break;
        case 'Surat Izin Keramaian':
            set_jenis = 'keramaian';

            break;
        case 'Surat Keterangan Jalan':
            set_jenis = 'surat-jalan';

            break;
        case 'Surat Pernyataan Kehilangan':
            set_jenis = 'kehilangan';

            break;
        case 'Surat Keterangan Kelahiran':
            set_jenis = 'kelahiran';

            break;
        case 'Surat Keterangan Kelahiran V2':
            set_jenis = 'keterangan-kelahiran';

            break;
        case 'Surat Keterangan Kematian V2':
            set_jenis = 'keterangan-kematian';

            break;
        case 'Surat Keterangan Kematian':
            set_jenis = 'kematian';

            break;
        case 'Surat Keterangan Kepemilikan Rumah':
            set_jenis = 'kepemilikan-rumah';

            break;
        case 'Surat Keterangan Ahli Waris':
            set_jenis = 'ahli-waris';

            break;
        case 'Surat Keterangan Domisili':
            set_jenis = 'domisili';

            break;

        case 'Surat Domisili':
            set_jenis = 'domisili/ii';

            break;
        case 'Surat Keterangan Usaha':
            set_jenis = 'usaha';

            break;
        case 'Surat Usaha':
            set_jenis = 'usaha/ii';

            break;
        case 'Surat Kuasa SKGR':
            set_jenis = 'skgr';

            break;
        case 'Surat Keterangan Penghasilan':
            set_jenis = 'penghasilan';

            break;
        case 'Surat Keterangan Pernah Menikah':
            set_jenis = 'pernah-menikah';

            break;
        case 'Surat Pengantar Pindah Nikah':
            set_jenis = 'pindah-nikah';

            break;
        case 'Surat Pengantar SKCK':
            set_jenis = 'skck';

            break;
        case 'Surat Keterangan Tidak Mampu':
            set_jenis = 'tidak-mampu';

            break;
        case 'Surat Pernyataan Tidak Menikah':
            set_jenis = 'tidak-menikah';

            break;
        case 'Surat Keterangan Domisili Usaha':
            set_jenis = 'domisili-usaha';

            break;
        case 'Surat Keterangan Penyaksian Tanah':
            set_jenis = 'penyaksian-tanah';

            break;
        case 'Surat Keterangan Pindah Datang WNI':
            set_jenis = 'surat-pindah-datang';

            break;
        case 'Surat Kuasa':
            set_jenis = 'surat-kuasa';

            break;
        case 'Surat Undangan':
            set_jenis = 'undangan';

            break;
        case 'Surat Izin Mendirikan Bangunan':
            set_jenis = 'izin-mendirikan-bangunan';

            break;
        case 'Surat Keterangan Izin Mendirikan Bangunan':
            set_jenis = 'izin-mendirikan-bangunan/ii';

            break;
        case 'Surat Keterangan Beda Nama':
            set_jenis = 'beda-nama';

            break;
        case 'Surat Keterangan Penghasilan Orang Tua':
            set_jenis = 'penghasilan-orang-tua';

            break;
        case 'Surat Keterangan Penguburan':
            set_jenis = 'penguburan';

            break;
        case 'Surat Keterangan Tidak Sengketa':
            set_jenis = 'tidak-sengketa';

            break;
        case 'Surat Pindah Desa BPN':
            set_jenis = 'surat-pindah-desa';

            break;
        case 'Surat Keterangan Gaib':
            set_jenis = 'surat-gaib';

            break;
        case 'Surat Keterangan Domisili Tanah':
            set_jenis = 'domisili-tanah';

            break;
        case 'Surat Belum Bekerja':
            set_jenis = 'tidak-bekerja';

            break;
        case 'Surat Keterangan Penghasilan Pandau':
            set_jenis = 'keterangan-penghasilan';

            break;
        case 'Surat Keterangan Status Perkawinan':
            set_jenis = 'status-perkawinan';

            break;
        case 'Surat Keterangan Ahli Waris Pandau':
            set_jenis = 'keterangan-ahli-waris';

            break;
        case 'Blangko Nikah':
            set_jenis = 'nikah';

            break;
        case 'Surat Pernyataan Ahli Waris':
            set_jenis = 'pernyataan-ahli-waris';

            break;
        case 'Surat Keterangan Pernikahan':
            set_jenis = 'keterangan-pernikahan';

            break;
        case 'Surat Kuasa Ahli Waris':
            set_jenis = 'kuasa-ahli-waris';

            break;

        case 'Surat Perintah Tugas V2':
            set_jenis = 'perintah-tugas/ii';

            break;

        // TAMBAHKAN JENIS SURAT BARU DIATAS INI
        // Surat Keterangan
        case 'Surat Keterangan':
            set_jenis = 'keterangan';

            break;
        // End Surat Keterangan
        default:
            set_jenis = null;
            break;
        // ================================
        // case 'Surat Keterangan Tidak Mampu':
        // 	set_jenis = 'tidak-mampu';
        // 	break;
        // case 'Surat Keterangan Domisili':
        // 	set_jenis = 'domisili';
        // 	break;
        // case 'Surat Keterangan Ahli Waris':
        // 	set_jenis = 'ahli-waris';
        // 	break;
        // case 'Surat Keterangan Kelahiran':
        // 	set_jenis = 'kelahiran';
        // 	break;
        // case 'Surat Keterangan Kematian':
        // 	set_jenis = 'kematian';
        // 	break;
        // case 'Surat Keterangan Penghasilan':
        // 	set_jenis = 'penghasilan';
        // 	break;
        // case 'Surat Keterangan Pernah Menikah':
        // 	set_jenis = 'pernah-menikah';
        // 	break;
        // case 'Surat Kuasa':
        // 	set_jenis = 'kuasa';
        // 	break;
        // case 'Surat Kuasa SKGR':
        // 	set_jenis = 'kuasa';
        // 	break;
        // case 'Surat Undangan':
        // 	kop_surat = 'surat-undangan';
        // 	set_jenis = '';
        // 	break;
    }
    return set_jenis;
}